import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Footer from "./Footer";

const WebDevelopmentDiagram = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Scroll to top when component loads
    window.scrollTo(0, 0);
  
    const handleScroll = () => {
      const diagram = document.getElementById("web-diagram");
      if (diagram) {
        const rect = diagram.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          setAnimate(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

   
        

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const callouts = [
    {
      text: "Content Management Systems",
      bgColor: "#e67e22",
    
    // bgColor: "linear-gradient(145deg, #1F6788, black)",
      rotate: "-35deg",
      top: isMobile ? "20%" : "20%",
      left: isMobile ? "6%" : "-5%",
    },
    {
      text: "Web Design",
      bgColor: "#f1c40f",
      
      rotate: "0deg",
      top: isMobile ? "8%" : "10%",
      left: isMobile ? "51%" : "52%",
    },
    {
      text: "ASP.NET, PHP, HTML",
      bgColor:   "#94E3ED",
      rotate: "0deg",
      top: isMobile ? "8%" : "10%",
      right: isMobile ? "51%" : "52%",
    },
    {
      text: "E-Commerce",
      bgColor: "#27ae60",
      rotate: "35deg",
      top: isMobile ? "20%" : "20%",
      right: isMobile ? "6%" : "-5%",
    },
  ];

  return (
    <>
      {/* First Section - Background Image */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: "100vh",
          backgroundImage: `url("/image/startup-min.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          color: "white",
          overflow: "hidden",
         

         
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
         //   backgroundColor: "rgba(0, 0, 0, 0.5)",
      

          }}
        />
        <Box
          sx={{
            position: "relative",
            maxWidth: "700px",
            marginLeft: { xs: "3%", md: "8%" },
            marginTop: { xs: "15%", md: "10%" },
            zIndex: 1,
            padding: 4,
      

          }}
        >
          <Typography
            variant="h3"
            sx={{ fontWeight: "bold", mb: 2, fontSize: { xs: "5vw", md: "42px" } }}
          >
            Web Sites and Web Applications
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: { xs: "3.5vw", md: "18px" }, lineHeight: 1.5 }}
          >
            {[
              "Successful development must work hand in hand with good UX design.",
              "At Tech Informatic Solutions, our expert development team works on the cutting edge of technology and best practices.",
              "We make websites built for performance. Our methodology is proven for each industry we serve.",
              "We provide a dedicated team of specialized experts.",
              "The web is changing rapidly, so it’s paramount that our development team maintain a passion for the digital world.",
              "All our developers work together to ensure that best practice is debated and agreed, and discoveries of new technologies and techniques are shared.",
            ].map((line, index) => (
              <Typography key={index} component="p" sx={{ mb: 1 }}>
                {line}
              </Typography>
            ))}
          </Typography>
        </Box>
      </Box>

      {/* Second Section - Diagram */}
      <Box
  sx={{
    width: "100%",
    minHeight: "100vh",
  //  backgroundImage: `url("/image/websites1.jpg")`, // Change to your preferred background image
 background: "radial-gradient(circle, #1F6788,#161623)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundAttachment: "fixed", // Enables the parallax effect
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>
  {/* WEB DEVELOPMENT SECTION */}
  <Box
    id="web-diagram"
    sx={{
      width: "100%",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px",
      mt: isMobile ? "80px" : "80px",
    }}
  >
    <Box
      sx={{
        position: "relative",
        width: isMobile ? "350px" : "800px",
        height: isMobile ? "350px" : "800px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        perspective: "1200px",
      }}
    >
      {/* Cloud Image Animation */}
      <Box
        component="img"
        src="/image/cloud2.png"
        alt="Cloud"
        sx={{
          width: isMobile ? "190px" : "650px",
          height: isMobile ? "90px" : "250px",
          position: "absolute",
          opacity: animate ? 1 : 0,
          transition: "opacity 1s ease-in-out",
          backgroundColor:"none"
        }}
      />
      <Typography
        variant="h6"
        sx={{
          position: "absolute",
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
          fontSize: isMobile ? "8px" : "20px",
        }}
      >
        WEB DEVELOPMENT SERVICES
      </Typography>

      {/* Callout Boxes Animation */}
      {callouts.map((callout, index) => (
        <Box
          key={index}
          sx={{
            position: "absolute",
            width: isMobile ? "50px" : "180px",
            height: isMobile ? "50px" : "120px",
            backgroundColor: callout.bgColor,
            borderRadius: "12px",
            textAlign: "center",
            color: "white",
            fontSize: isMobile ? "10px" : "16px",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
            transform: `rotate(${callout.rotate})`,
            top: callout.top,
            left: callout.left,
            right: callout.right,
            opacity: animate ? 1 : 0,
            transition: `opacity 0.8s ease-in-out ${index * 0.5}s`,
            boxShadow: `
              0px 12px 25px rgba(0, 0, 0, 0.6),  
              inset 0px 10px 20px rgba(255, 255, 255, 0.15),
              inset 0px -10px 30px rgba(0, 0, 0, 0.7),
              inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
              inset -10px 0px 20px rgba(255, 255, 255, 0.2)
            `,
          }}
        >
          {callout.text}
          <Box
                  sx={{
                    position: "absolute",
                    bottom: "-15px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 3,
                    height: 0,
                    borderLeft: "10px solid transparent",
                    borderRight: "10px solid transparent",
                    borderTop: "15px solid red",
                    
                  }}
                />

        </Box>
      ))}
    </Box>
  </Box>

  {/* TEXT DESCRIPTION */}
  <Box
    sx={{
      width: "100%",
      textAlign: "left",
      padding: isMobile ? "20px" : "50px",
      boxSizing: "border-box",
      mt: isMobile ? "-80px" : "-180px",
    }}
  >
    <Typography
      variant="body1"
      sx={{
        lineHeight: 1.6,
        fontSize: isMobile ? "1rem" : "1.2rem",
        color: "white",
      }}
    >
     All our developers use HTML5 , PHP and CSS3, and have an in-depth knowledge of Search Engine Optimisation (SEO), to ensure that all our sites are built with SEO in mind. We code mainly in PHP, using open-source software such as WordPress and TYPO3 content management systems which are flexible, extendible and customisable to fit with our client’s needs.     </Typography>
 
     <Typography
          variant="body1"
          sx={{
            lineHeight: 1.6,
            fontSize: isMobile ? "1rem" : "1.2rem",
            mt: 2,
            color: "white",
            
          }}
        >
    A key aspect of each developer’s role is to set up the Content Management System (CMS) in a way that the website is easy for our clients to edit, so we test extensively to make sure that is the case.  </Typography>
   
    <Typography
          variant="body1"
          sx={{
            lineHeight: 1.6,
            fontSize: isMobile ? "1rem" : "1.2rem",
            mt: 2,
            color: "white",
            
          }}
        >
   We work with you to develop a user experience which delivers value to your audience which encourages repeat visits and referrals via social media and other channels. Taking advantage of these resources and holding true to current and effective web practices, Tech Informatic Solutions web design and development solutions are customized to help you achieve your digital marketing goals.  </Typography>



  </Box>

  {/* CONTENT MANAGEMENT & UI/UX SECTION */}
  <Box
    sx={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "center",
      py: 6,
      px: 2,
      minHeight: "100vh",
     // backgroundImage: `url("/image/grey6.jpg")`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
    }}
  >
    {/* Left Side Content */}
    <Box
      sx={{
        flex: 1,
        px: 2,
        textAlign: isMobile ? "center" : "left",
        maxWidth: isMobile ? "100%" : "25%",
        mb: isMobile ? 4 : 0,
        mt: isMobile ? 3 : -5,
      }}
    >
      <Typography variant="h4" fontWeight="bold" color="white">
        Content Management Systems
      </Typography>
      <Typography
        variant="body1"
        sx={{
          lineHeight: 1.6,
          fontSize: isMobile ? "1rem" : "1.2rem",
          mt: 2,
         // fontWeight: "bold",
          color: "white",
        }}
      >
         Using the latest technologies, we can develop custom content management systems and databases that allow web editors to easily manage and update site content.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.6,
              fontSize: isMobile ? "1rem" : "1.2rem",
              mt: 2,
             // fontWeight: "bold",
              color: "white",
            }}
          >
            The applications, or modules, managed by the content management systems can include calendar and event postings, in addition to unique membership login and member based content.
          </Typography>

    </Box>

    {/* Center Image */}
    <Box
      sx={{
        flex: 2,
        display: "flex",
        justifyContent: "center",
        px: 2,
        maxWidth: isMobile ? "100%" : "50%",
      }}
    >
      <img
        src="/image/flowd.png"
        alt="Industry Insights"
        style={{
          width: isMobile ? "95%" : "100%",
          maxWidth: isMobile ? "500px" : "800px",
          height: isMobile ? "auto" : "100%",
          maxHeight: isMobile ? "450px" : "600px",
          objectFit: "contain",
        }}
      />
    </Box>

    {/* Right Side Content */}
    <Box
      sx={{
        flex: 1,
        px: 2,
        textAlign: isMobile ? "center" : "left",
        maxWidth: isMobile ? "100%" : "25%",
        mt: isMobile ? 5 : 1,
      }}
    >
      <Typography variant="h4" fontWeight="bold" color="white">
        UI/UX Web Design
      </Typography>
      <Typography
        variant="body1"
        sx={{
          lineHeight: 1.6,
          fontSize: isMobile ? "1rem" : "1.2rem",
          mt: 2,
          color: "white",
       //   fontWeight: "bold",
        }}
      >
        With our in-house award winning web and graphic designers, we recognize the fact that usability, functionality and visualization are three of the most important factors when designing an application interface or web site. Using this strategy, we work with you to ensure that your digital marketing goals are realized with the designs we create.

<Typography
variant="body1"
sx={{
 lineHeight: 1.6,
 fontSize: isMobile ? "1rem" : "1.2rem",
 mt: 2,
 color: "white",
 //fontWeight: "bold",
}}
>

Our process, which we’ve constantly developed and streamlined over the years, focuses on getting to know you, your company, and most importantly, your target audience. By adhering to this practice we’re able to develop a design concept that will meet both your expectations and your marketing goals.
</Typography>
</Typography>

    </Box>
  </Box>
</Box>

<Footer />
</>
);
};
export default WebDevelopmentDiagram;
